import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import * as styles from "./MarkdownContent.module.css";

interface Props {
    children: string;
    className?: string;
}

export default function MarkdownContent({children, className}: Props) {
    const markdownClassName = className ? `${styles.markdown} ${className}` : styles.markdown;

    return (
        <ReactMarkdown className={markdownClassName} remarkPlugins={[remarkGfm]}>
            {children}
        </ReactMarkdown>
    );
}
